/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import usePluginUtils from "./usePluginUtils";

export const useBookingApiEntities = (sourceType = "booking") => {
  const { isPluginEnabled } = usePluginUtils();

  const includeEntities = useMemo(() => {
    const prefix = sourceType === "invoice" ? "lines.bookings." : "";

    const entities = [
      "service",
      "provider",
      isPluginEnabled("location") && "location",
      isPluginEnabled("event_category") && "category",
      isPluginEnabled("online_meeting") && "online_meeting",
      sourceType === "booking" && "invoice",
    ].filter(Boolean);

    return entities.map((e) => `${prefix}${e}`).join(",");
  }, [isPluginEnabled, sourceType]);

  return { includeEntities };
};
